import React, { useState } from "react";
import "./SideBar.scss";
import {
  HiHomeModern,
  HiListBullet,
  HiInformationCircle,
  HiPhoto,
  HiBuildingLibrary,
  HiPuzzlePiece,
  HiArrowLeft,
  HiBars3,
  HiBuildingOffice2,
} from "react-icons/hi2";
import LanguageToggle from "../../LanguageToggle/LanguageToggle";
import SideBarMenu from "./SideBarMenu/SideBarMenu";
import { useTranslation } from "react-i18next";

export default function SideBar() {
  const { t } = useTranslation("links");
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const SideBarLinks = [
    {
      name: t("home"),
      href: "/",
      icon: <HiHomeModern />,
    },
    {
      name: t("menu"),
      href: "/menu",
      icon: <HiListBullet />,
    },
    {
      name: t("about_us"),
      href: "/about-us",
      icon: <HiInformationCircle />,
    },
    {
      name: t("gallery"),
      href: "/gallery",
      icon: <HiPhoto />,
    },
    {
      name: t("apartments"),
      href: "/apartments",
      icon: <HiBuildingOffice2 />,
    },
    {
      name: t("halls"),
      icon: <HiBuildingLibrary />,
      subLinks: [
        { name: t("great_hall"), href: "/great-hall" },
        { name: t("crystal_hall"), href: "/crystal-hall" },
        { name: t("small_hall"), href: "/small-hall" },
      ],
    },
    {
      name: t("playroom"),
      href: "/playroom",
      icon: <HiPuzzlePiece />,
    },
  ];
  return (
    <>
      <button className="toggle-drawer" onClick={() => setIsSideBarOpen(true)}>
        <HiBars3 />
      </button>
      <div className={`sidebar ${isSideBarOpen ? "open" : ""}`}>
        {/* SideBar CLose/Language Toggle */}
        <div className="sidebar__top">
          <button
            className="sidebar__close"
            onClick={() => setIsSideBarOpen(false)}
          >
            <HiArrowLeft />
          </button>
          <LanguageToggle />
        </div>
        {/* SideBar Links */}
        <SideBarMenu SideBarLinks={SideBarLinks} />
      </div>
    </>
  );
}
